import { useState } from "react";
import { createPengecekanSaved } from "../../utils/editorHelpers";

const useEditorState = () => {
  // data state
  const [pengecekanSaved, setPengecekanSaved] = useState(
    createPengecekanSaved()
  );

  const [pengecekanPertama, setPengecekanPertama] = useState(false);

  const [modeAmbilGambar, setModeAmbilGambar] = useState(false);

  const [headerData, setHeaderData] = useState({
    tanggal: new Date(),
    kendaraan_id: null,
    data_kendaraan: null,
    trailer_id: null,
    km: null,
    keterangan: "",
  });
  const [headerError, setHeaderError] = useState({});

  // an audit has ONE pengecekan (no berangkat / kembali): the header with its detils
  const [pengecekanData, setPengecekanData] = useState();

  const [pengecekanDetilData, setPengecekanDetilData] = useState([]);

  const [listProblemData, setListProblemData] = useState([]);

  return {
    pengecekanSaved,
    setPengecekanSaved,
    pengecekanPertama,
    setPengecekanPertama,
    modeAmbilGambar,
    setModeAmbilGambar,
    headerData,
    setHeaderData,
    headerError,
    setHeaderError,
    pengecekanData,
    setPengecekanData,
    pengecekanDetilData,
    setPengecekanDetilData,
    listProblemData,
    setListProblemData,
  };
};

export default useEditorState;
